import React from 'react'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import Preview from '../../../components/pdf/Preview'
import OptionsForm from './options/OptionsForm'
import PdfDocument from './PdfDocument'
import { COLORS } from '@btime/constants'

const PageContent = () => {
  return (
    <FlexGrid align="stretch">
      <FlexCol flex={3} bgColor={COLORS.light3}>
        <Preview>
          <PdfDocument />
        </Preview>
      </FlexCol>

      <FlexCol flex={1}>
        <OptionsForm />
      </FlexCol>
    </FlexGrid>
  )
}

export default PageContent
